export enum ResolutionsEnum {
  mobile = 420,
  tablet = 768,
  desktop = 1024,
  desktopSmall = 1200,
  desktopLarge = 1440,
  desktopWide = 1920,
  desktopExtraWide = 2560
}

